import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemeService } from '../../../../services/shared/theme.service';
import { MbscModule } from '@mobiscroll/angular';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { SvgIconService } from '../../../../services/shared/icons/svg-icon.service';
import { PermissionService } from '../../../../services/permission.service';

@Component({
  selector: 'app-resource-template',
  standalone: true,
  imports: [CommonModule, MbscModule],
  templateUrl: './resource-template.component.html',
  styleUrls: ['./resource-template.component.scss'],
})
export class ResourceTemplateComponent {
  @Input() resource: any;
  @Input() isExporting: any;
  @Output() fixTeam = new EventEmitter<any>();
  @Output() unfixTeam = new EventEmitter<any>();
  @Output() exportResources = new EventEmitter<any>();
  @Input() minutesHidden = false;
  @Output() unkenntlich = new EventEmitter<void>();

  constructor(
    public themeService: ThemeService,
    public http: HttpClient,
    private sanitizer: DomSanitizer,
    public svgIconService: SvgIconService,
    public permissionService: PermissionService,
  ) {}

  //onImageError(id: any) {
  //  const img = document.getElementById('img' + id) as HTMLImageElement;
  //  if (img) img.style.display = 'none';
  //}

  onImageError(resource: any) {
    resource.img = 'FOTO_Dummy.jpg';
  }

  toRoundedHours(minutes: number): number {
    return Math.round((minutes / 60) * 100) / 100;
  }

  fixResource(resource: any) {
    this.fixTeam.emit(resource);
  }

  unfixResource(resource: any) {
    this.unfixTeam.emit(resource);
  }

  doScreenshot(selectedTeam: any) {
    const team = selectedTeam;

    //IDS AUS DEM TEAM EXTRAHIEREN
    const memberIds = team.children.map((c: { id: any }) => c.id);
    this.exportResources.emit({ memberIds, team });
  }

  doUnkenntlich(): void {
    this.unkenntlich.emit();
  }
}
